fourToldApp.controller('groupDetailsCntrl', function (xmppAuth, $http, services, esb, $location, $scope, $rootScope, $cookieStore, $cookies, $localStorage, $mdDialog, $window, $filter, $mdToast) {

    $scope.currentTab = 0;
    $scope.viewTemplate = $window.sessionStorage.getItem("viewTemplate");
    $scope.progress = undefined;
    $scope.members = JSON.parse($window.sessionStorage.getItem("members"));
    $scope.groupId = JSON.parse($window.sessionStorage.getItem("groupId"));
    $scope.groupTypeId = JSON.parse($window.sessionStorage.getItem("groupTypeId"));

    $scope.user = services.user.getData();
    $scope.getMemberImg = function(item) {
        return esb +"/security/" + item.selfieUrl;
    }
    $scope.showDeleteMember = function(ev, member) {
    var confirm = $mdDialog.confirm()
                  .textContent('¿Esta seguro que desea eliminar a  ' + member.firstName + ' ' + member.lastName + '?')
                  .ariaLabel('enviar')
                  .targetEvent(ev)
                  .ok('Eliminar')
                  .cancel('Cancelar');
            $mdDialog.show(confirm).then(function() {
              $scope.progressCircular = "ok"; 
              
              services.groups.groupsServices('bearer ' + $window.localStorage.getItem('access_token1')).deleteMemberFromGroup ({groupId: $scope.groupId,  memberId: member.entityId}, {}, function(response, event){                 
                  $scope.getGroups();
              });
           
            }, function(){ });


        }
        $scope.getGroups = function() {
            $scope.progress = "ok";        
            $scope.references = []; 
            services.groups.groupsServices('bearer ' + $window.localStorage.getItem('access_token1')).list({}, function(response) {
                $scope.progress = undefined;
                if (response.data) {
                    if (response.data === undefined) {
                        $scope.dataExists = undefined;
                    } else {                        
                        $scope.dataExists = "data";
                        var groupTypes = response.data.groupTypes;
                        var groups = [];
                        for (groupType of groupTypes) {
                            if(groupType.id == $scope.groupTypeId) {
                                groups = groupType.groups; 
                                break;
                            }    
                        }

                        for (var group of groups) {                            
                            if(group.id == $scope.groupId)
                            $scope.members = group.members;
                        }                        
                    } 
                }
            }, function(error) {
                $scope.showAlert("Ocurrio un error", "Pongase en contacto con soporte tecnico");
            }) 
        }; 

    $scope.showMeetingUpdate = function(ev, meeting) {
        $scope.disabledBtn = true;
        $window.sessionStorage.setItem("meeting",  JSON.stringify(meeting));
        var confirm = $mdDialog.show({
            controller: 'updateMeetingCntrl',
            templateUrl: 'views/dashboard/updateMeeting.html',
            parent: angular.element(document.body),
            targetEvent: ev
        }).then(function(answer) {
          console.log(answer);
          $scope.getMeetings();
          }, function() {
              $scope.disabledBtn = false;
          });
    };

    $scope.changeTab = function (tabIndex) {
        $scope.currentTab = tabIndex;
    };

    $scope.actionCancel = function () {
        location.href = '#/' + $scope.viewTemplate;
    };
    
    $scope.formatAMPM = function(date) {
        var hours = date.getUTCHours();
        var minutes = date.getUTCMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;  
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    
    $scope.getMeetings = function() {
        $scope.progress = "ok";        
        $scope.references = []; 
        services.groups.groupsServices('bearer ' +  $window.localStorage.getItem('access_token1')).meetings({}, function(response) {
            $scope.progress = undefined;
            if (response.data) {
                if (response.data === undefined) {
                    $scope.dataExists = undefined;
                } else {
                    $scope.dataExists = "data";
                    $scope.meetings = response.data;  
                } 
            }
        }, function(error) {
            $scope.showAlert("Ocurrio un error", "Pongase en contacto con soporte tecnico");
        })     
    }

    $scope.getDayWeekName = function(meeting) {        

        var days = ['DOMINGO','LUNES','MARTES','MIÉRCOLES','JUEVES','VIERNES','SÁBADO'];
        var dayOfWeek = days[new Date(meeting.meetingTime).getUTCDay()]      
        return dayOfWeek;
    }
    $scope.getDayNumber = function(meeting) {
        var number = new Date(meeting.meetingTime).getUTCDate();
        return number;
    }
    $scope.getMonthName = function(meeting) {
        var meses = new Array ("ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE");
        var mes =  meses[new Date(meeting.meetingTime).getUTCMonth()];
        return mes;
    }

    $scope.getTime = function(meeting) { 
        var meetingTime = new Date(meeting.meetingTime)            
        return  $scope.formatAMPM(meetingTime);
    }
    $scope.convertArray = function (item) {
        //console.log(item);
        item = item.toString();
        item = item.replace('[', '');
        item = item.replace(']', '');
        item = item.replace(',', ', ');
        return item;
    };

      

    $scope.elementAry = function (data) {
        $scope.elementHeaders = [];
        angular.forEach(data, function (val, key) {
            $scope.elementHeaders.push({
                key: key,
                val: val
            });
        });
        //console.log($scope.elementHeaders);
        return $scope.elementHeaders;
    };

    $scope.showInfo = function (data) {
        if (data == 1) {
            if ($scope.viewData.viewInfoDetails)
                $scope.viewData.viewInfoDetails = undefined;
            else
                $scope.viewData.viewInfoDetails = true;
            return $scope.viewData.viewInfoDetails;
        }
        if (data == 2) {
            if ($scope.viewData.viewInfoPayment)
                $scope.viewData.viewInfoPayment = undefined;
            else
                $scope.viewData.viewInfoPayment = true;
            return $scope.viewData.viewInfoPayment;
        }
        if (data == 3) {
            if ($scope.viewData.viewInfoCurrent)
                $scope.viewData.viewInfoCurrent = undefined;
            else
                $scope.viewData.viewInfoCurrent = true;

            return $scope.viewData.viewInfoCurrent;
        }
        if (data == 4) {
            if ($scope.viewData.viewInfoPersonal)
                $scope.viewData.viewInfoPersonal = undefined;
            else
                $scope.viewData.viewInfoPersonal = true;

            return $scope.viewData.viewInfoPersonal;
        }
        if (data == 5) {
            if ($scope.viewData.viewInfoFeedata)
                $scope.viewData.viewInfoFeedata = undefined;
            else
                $scope.viewData.viewInfoFeedata = true;

            return $scope.viewData.viewInfoFeedata;
        }
    }

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

});
